import { withScope, captureMessage } from "@sentry/vue";
export default function (error, additional) {
    const { level = "error", customTitle = undefined, additionalDetails = undefined } = additional;
    let title;
    if (error instanceof Error) {
        if (error.message && error.message.includes("Not authorized")) {
            return;
        }
        title = customTitle || error.message;
    }
    else {
        const { graphQLErrors } = error;
        title = graphQLErrors[0].message;
    }
    withScope(scope => {
        scope.setContext("error_details", {
            error: JSON.stringify(error),
            additionalDetails
        });
        scope.setLevel(level);
        scope.setTag("network_error", "graphql_error");
        captureMessage(title);
    });
}
export function SentryCaptureError(error, additional) {
    const { level = "error", customTitle = undefined, additionalDetails = undefined } = additional;
    let title;
    if (error instanceof Error) {
        if (error.message && error.message.includes("Not authorized")) {
            return;
        }
        title = customTitle || error.message;
    }
    else {
        const { graphQLErrors } = error;
        title = graphQLErrors[0].message;
    }
    withScope(scope => {
        scope.setContext("error_details", {
            error: JSON.stringify(error),
            additionalDetails
        });
        scope.setLevel(level);
        scope.setTag("network_error", "graphql_error");
        captureMessage(title);
    });
}
